export const pluralise = (quantity = 0, noun: string, includeQty = true, suffix = 's'): string =>
  `${includeQty ? `${quantity.toLocaleString()} ` : ''}${noun}${quantity !== 1 ? suffix : ''}`;
